import axios from 'axios';
import Config from "../../../config";
import history from "../../../history";

let axiosIntervalInstance = axios.create();
let qs = require('qs');
let isAlreadyFetchingAccessToken = false;
let subscribers = [];

function onAccessTokenFetched(access_token) {
    subscribers = subscribers.filter(callback => callback(access_token))
}

function addSubscriber(callback) {
    subscribers.push(callback)
}

axiosIntervalInstance.interceptors.response.use(function (response) {
    return response
}, function (error) {
    const {config, response: {status}} = error;
    const originalRequest = config;

    if (status === 401) {
        if (!isAlreadyFetchingAccessToken) {
            isAlreadyFetchingAccessToken = true;
            axios.post(Config.apiUrl + '/api/v1/public/oauth/token',
                qs.stringify({
                    grant_type: 'refresh_token',
                    refresh_token: localStorage.getItem("refresh_token")
                }), {
                    headers: {
                        'Authorization': 'Basic c3ByaW5nLXNlY3VyaXR5LW9hdXRoMi1yZWFkLXdyaXRlLWNsaWVudDpzcHJpbmctc2VjdXJpdHktb2F1dGgyLXJlYWQtd3JpdGUtY2xpZW50LXBhc3N3b3JkMTIzNA=='
                    }
                }).then((response) => {
                localStorage.setItem('access_token', response.data.access_token);
                isAlreadyFetchingAccessToken = false;
                onAccessTokenFetched(response.data.access_token);
            }).catch(err => {
                localStorage.clear();
                history.push('/login');
                window.location.reload();
            });
        }

        const retryOriginalRequest = new Promise((resolve) => {
            addSubscriber(access_token => {
                originalRequest.headers.Authorization = 'Bearer ' + access_token
                resolve(axios(originalRequest))
            })
        });
        return retryOriginalRequest
    }
    return Promise.reject(error)
});

export default axiosIntervalInstance;



// WEBPACK FOOTER //
// ./src/main/content/common/AxiosIntervalInstance.js